import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const LogoutSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
          <div className="text-center">
            <CheckCircle2 className="mx-auto h-16 w-16 text-green-500 mb-4" />
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Successfully Logged Out
            </h1>
            <p className="text-gray-600 mb-8">
              You have been securely logged out of your QuizCrunch account.
            </p>
            <div className="space-y-4">
              <button
                onClick={() => signIn()}
                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded-md transition-colors"
              >
                Sign In Again
              </button>
              <button
                onClick={() => navigate('/')}
                className="w-full border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold py-2 px-4 rounded-md transition-colors"
              >
                Go to Home Page
              </button>
            </div>
            <p className="mt-6 text-sm text-gray-500">
              Thank you for using QuizCrunch!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutSuccess;